<template>
  <div class="container-fluid">
    <b-card class="mt-3 mb-1">
      <b-card-header class="p-0"
        ><b-card-body class="px-0 py-1">
          <b-card-title class="card-title-doorder my-1"
            >Upload Mass Order
          </b-card-title>
        </b-card-body>
      </b-card-header>
    </b-card>

    <b-form @submit.prevent="onSubmit" ref="addMassOrderForm">
      <b-card no-body class="">
        <b-card-body>
          <b-row>
            <b-col>
              <b-form-group
                class="form-group-doorder form-group-upload-files"
                label="Upload Excel Sheet"
                label-for="fileRecords"
                :fileRecords="fileRecords"
                label-class="form-label-doorder"
              >
                <p class="error_validation_message_p" v-if="invalid_file">
                  Please upload file
                </p>
              </b-form-group>
              <VueFileAgent
                id="fileRecords"
                class="upload-files-fileagent-doorder"
                ref="vueFileAgent"
                :theme="'list'"
                accept=".csv,.xlsm, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :multiple="false"
                :linkable="true"
                :deletable="true"
                :meta="true"
                :helpText="'Click here to upload your file'"
                :errorText="{
                  type: 'Invalid file type. Only excel files allowed',
                  size: 'Files should not exceed 10MB in size',
                }"
                @select="filesSelected($event)"
                @beforedelete="onBeforeDelete($event)"
                @delete="fileDeleted($event)"
                v-model="fileRecords"
              ></VueFileAgent>
              <!-- <button
              :disabled="!fileRecordsForUpload.length"
              @click="uploadFiles()"
            >
              Upload {{ fileRecordsForUpload.length }} files
            </button> -->
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="6">
              <b-form-group
                class="form-group-doorder"
                label="Address"
                label-for="pickup_address"
                label-class="form-label-doorder"
              >
                <p class="error_validation_message_p" v-if="invalid_address">
                  Please select address
                </p>
                <v-select
                  :options="addresses"
                  v-model="address"
                  :name="address"
                  :title="address"
                  placeholder="Select address"
                  label="address"
                  :reduce="(item) => item.id"
                  :clearable="false"
                  required
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <input type="hidden" name="client" v-model="client_name" />
      <b-row class="my-4">
        <b-col lg="4" md="6" class="mx-auto">
          <b-button
            type="submit"
            variant="doorder-primary"
            class="btn btn-bumblebee btn-doorder btn-submit-register mx-auto"
            v-if="!is_loading"
            >Submit</b-button
          >
          <b-button
            type="button"
            disabled
            variant="doorder-primary"
            class="btn btn-bumblebee btn-doorder btn-submit-register mx-auto"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DoOrderAddMassOrder",
  components: {},
  data() {
    return {
      client_name: "DOORDER",
      type: "retailer",
      retailer_id: null,
      user_title: null,
      addresses: [],
      address: null,
      invalid_address: false,
      is_loading: false,
      fileRecords: [],
      fileRecordsForUpload: [],
      invalid_file: false,
      isopen: true,
    };
  },
  updated() {},
  watch: {},
  mounted() {
    console.log("in add mass order mounted");

    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log(user);
    this.user_id = user.id;
    this.user_title = user.type;
    console.log(this.user_id, this.user_title);
    this.getRetailerViewData(user.id);
  },
  methods: {
    setopen(VueSelect) {
      return true;
    },
    getRetailerViewData(retailer_id) {
      axios
        .get("/retailer/profile/" + retailer_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          let retailer = response.data.retailer;
          this.addresses = retailer.locations;
        });
    },

    async onSubmit() {
      console.log("submit add mass order");
      console.log(this.fileRecords);
      console.log(this.fileRecordsForUpload);
      console.log(this.address);
      this.is_loading = true;

      if (this.address == null || this.address == "") {
        this.invalid_address = true;
      } else {
        this.invalid_address = false;
      }
      if (
        this.fileRecordsForUpload == null ||
        this.fileRecordsForUpload.length == 0
      ) {
        this.invalid_file = true;
      } else {
        this.invalid_file = false;
      }

      if (!this.invalid_file && !this.invalid_address) {
        let formData = new FormData();
        formData.append("client", this.client_name);
        formData.append("owner_id", this.user_id);
        formData.append("owner_type", this.user_title);
        formData.append("address", this.address);
        formData.append("jobs-file", this.fileRecordsForUpload[0].file);

        axios
          .post("jobs/import-jobs", formData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          })
          .then((response) => {
            console.log(response);
            this.$fire({
              // title: "Title",
              text: response.data.success,
              type: "success",
              customClass: {
                container: "swal-alert-doorder",
                confirmButton:
                  "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
                cancelButton:
                  "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
              },
              // timer: 3000,
            }).then((r) => {
              console.log(r.value);
              this.is_loading = false;
              this.$router.go();
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.is_loading = false;
            this.$fire({
              // title: "Title",
              text: error.response.data.error
                ? error.response.data.error
                : error.response.data.message,
              type: "error",
              customClass: {
                container: "swal-alert-doorder",
                confirmButton:
                  "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
                cancelButton:
                  "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
              },
              // timer: 3000,
            }).then((r) => {
              // console.log(r.value);
            });
          });
      } else {
        this.is_loading = false;
      }
    },

    ////////// file agent functions
    uploadFiles: function () {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload);
      // this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
    },
    filesSelected: function (fileRecordsNewlySelected) {
      console.log(fileRecordsNewlySelected);
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      console.log(validFileRecords);
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);
      console.log(this.fileRecordsForUpload);
      console.log(this.fileRecords);
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
      } else {
        if (confirm("Are you sure you want to delete?")) {
          this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
        }
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else {
        this.deleteUploadedFile(fileRecord);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/doorder/orders/AddMassOrder.vue